import { ReportRepository } from "@domain/repositories/ReportRepository";
import UseCase from "@domain/UseCase";
import { Report } from "@domain/models/Report";

type Input = {
  clientId: string;
};

type Output = Promise<Report[]>;

export class GetClientReportsUseCase implements UseCase<Input, Output> {
  constructor(private readonly reportRepository: ReportRepository) {}

  execute({ clientId }: Input) {
    return this.reportRepository.getClientReports(clientId);
  }
}
